import React from 'react'
import { Link } from 'react-router-dom'
import _ from 'lodash'

class Option extends React.Component {
  constructor(props) {
    super(props);
    this.item = props.item;
    this.onSelect = props.onSelect;
  }

  onItemSelected() {
    this.onSelect(this.item);
  }

  get isSelected() {
    return _.find(this.props.selected, {id: this.item.id, type: this.item.type});
  }

  render() {
    return (
      <li key={this.item.id} onClick={this.onItemSelected.bind(this)} className={`simple-options-list-item selectable-block ${this.isSelected ? 'selected' : ''}`}>
        { this.item.hint ? (
          <div className="hint">{ this.item.hint }</div>
        ) : null }
        <div className='selectable-block-indicator'></div>
        <div className='simple-options-list-item-content'>
          <div className="image">
            <img src={_.get(this.item, 'preview.url')} />
          </div>
          <div className='simple-options-list-item-title'>
            <span>
              { this.item.title }
            </span>
          </div>
          <div className='simple-options-list-item-description'>
            { this.item.description }
          </div>
        </div>
      </li>
    )
  }
}

export default Option;



// WEBPACK FOOTER //
// ./app/javascript/app/components/simple_options_list/option.jsx